module.exports = __webpack_public_path__ + "static/media/network-2.bcbe7f21.jpg";